import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BrandingModule } from '@feature/branding';
import { UIIconModule } from '../icon/icon.module';
import { UIAppBarButtonComponent } from './app-bar-button/app-bar-button.component';
import { UINavigateBackDirective } from './app-bar-button/navigate-back.directive';
import { UIAppBarComponent } from './app-bar/app-bar.component';

@NgModule({
  declarations: [UIAppBarComponent, UIAppBarButtonComponent, UINavigateBackDirective],
  imports: [CommonModule, UIIconModule, BrandingModule],
  exports: [UIAppBarComponent, UIAppBarButtonComponent, UINavigateBackDirective],
})
export class UIAppBarModule {}
